var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.3807 11.551C5.15157 11.9956 6.04597 12.25 6.99979 12.25C9.89929 12.25 12.25 9.8995 12.25 7C12.25 4.10051 9.89949 1.75 7 1.75C4.1005 1.75 1.75 4.10051 1.75 7C1.75 7.95382 2.00436 8.84823 2.44895 9.6191L2.45067 9.62208C2.49345 9.69625 2.51502 9.73365 2.52479 9.769C2.534 9.80234 2.53658 9.83231 2.53422 9.86682C2.53168 9.9039 2.51918 9.94235 2.49356 10.0192L2.04508 11.3646L2.04452 11.3664C1.9499 11.6503 1.90258 11.7922 1.93631 11.8868C1.96571 11.9693 2.03098 12.0343 2.11344 12.0637C2.20781 12.0974 2.34911 12.0503 2.63174 11.9561L2.63525 11.9548L3.98069 11.5063C4.0573 11.4808 4.09625 11.4678 4.13326 11.4653C4.16777 11.4629 4.19754 11.466 4.23088 11.4753C4.26632 11.4851 4.30374 11.5066 4.37829 11.5496L4.3807 11.551Z",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentIcon);
export default __webpack_public_path__ + "static/media/comment-icon.de60d18ccce2421e1cc7fb5358be4841.svg";
export { ForwardRef as ReactComponent };